import SimpleBar from 'simplebar'
import 'simplebar/dist/simplebar.css'
import onResize from '../utils/onResize'
import emitter from '../utils/emitter'

export default {
  name: 'scroll-bar',

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    emitter.on('WEBFONT_LOADED', () => {
      this.calcHeight()
    })

    window.addEventListener('orientationchange', () => {
      this.calcHeight()
    })
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    this.calcHeight()
  },

  calcHeight () {
    let simplebar = null

    if (window.innerWidth > 991) {
      let el = this.el

      let elHeight = parseInt(getComputedStyle(el).height)

      let parent = el.parentNode

      let section = getComputedStyle(el.closest('.section'))

      let sectionHeight = parseInt(el.closest('.section').offsetHeight)

      let sectionPaddingTop = parseInt(section.paddingTop)

      let sectionPaddingBottom = parseInt(section.paddingBottom)

      let height = sectionHeight - sectionPaddingBottom - sectionPaddingTop - 1

      // apply height only if element height is bigger than allowed space
      if (elHeight >= height) {
        const scrollBox = el.closest('.scroll-box')

        // eslint-disable-next-line
        simplebar = new SimpleBar(el)
        parent.style.height = height + 'px'

        scrollBox.classList.add('has-scroll')
      } else {
        if (simplebar != null) {
          this.el.closest('.scroll-box').remove('has-scroll')
          simplebar.unmount()
          parent.style.height = 'auto'
        }
      }
    } else {
      if (simplebar != null) {
        this.el.closest('.scroll-box').remove('has-scroll')
        simplebar.unmount()
        parent.style.height = 'auto'
      }
    }
  },

  outerHeight (el) {
    let height = el.offsetHeight

    let style = getComputedStyle(el)

    height += parseInt(style.marginTop) + parseInt(style.marginBottom)
    return height
  },
}
